import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-business-partner-help',
    templateUrl: './business-partner-help.component.html',
    styleUrls: ['./business-partner-help.component.scss'],
})
export class BusinessPartnerHelpComponent implements OnInit {
    bpToken = '';
    showB2BHint = false;
    error = false;
    invalidToken = false;
    constructor(private route: ActivatedRoute) {}
    ngOnInit(): void {
        this.route.queryParams.subscribe((qp) => {
            this.bpToken = decodeURIComponent(qp['token'] || '');
            this.showB2BHint = decodeURIComponent(qp['showB2BHint'] || '') === 'true';
            this.error = decodeURIComponent(qp['error'] || '') === 'true';
            this.invalidToken = decodeURIComponent(qp['invalid-token'] || '') === 'true';
        });
    }
}
